import styled from 'styled-components';
import {colorTheme} from '../../../ui-toolkit/mixin/colorTheme';
import {CardColors} from '../componentColors/cardVariableColors';
import {formControlColors} from '../componentColors/formControlVariableColors';
import {ColorThemeContainerStates} from './ColorThemeContainerStates';

export const ColorThemeContainer = styled(ColorThemeContainerStates)`
    ${colorTheme({
        '--main-body-background-color-transp': {dark: '#fafafe00', light: '#fafafe00'},

        '--default-text-color  ': {dark: 'var(--white-00) ', light: 'var(--black-01)'},
        '--default-btn-text-color  ': {dark: 'var(--black-01) ', light: 'var(--white-00)'},
        '--label-text-color    ': {dark: 'var(--slate-06)         ', light: 'var(--slate-07)'},
        '--label-text-color-100': {dark: 'var(--slate-06)', light: 'var(--slate-06)'},
        '--label-text-color-200': {dark: 'var(--slate-06)         ', light: 'var(--slate-08)'},
        '--disabled-text-color-100': {dark: 'var(--gray-09)         ', light: 'var(--gray-02)'},

        '--container-background-color-100': {dark: 'var(--black-07)', light: 'var(--white-00)'}, //
        '--container-background-color-200': {dark: 'var(--black-04)        ', light: 'var(--slate-00)'}, //
        '--container-background-color-300': {dark: 'var(--black-15)        ', light: 'var(--gray-00)'},
        '--container-background-color-400': {dark: '#F6F8FA        ', light: 'var(--white-01)'},
        '--container-background-color-500': {dark: 'var(--black-13)        ', light: 'var(--gray-01)'},
        '--container-background-color-600': {dark: 'var(--black-08)  ', light: 'var(--white-00)'},

        '--container-background-color-backdrop    ': {dark: '#303031cc    ', light: '#021546bd'},

        '--container-border-color-000': {dark: '#F2F5F7', light: 'var(--white-03)'},
        '--container-border-color-100': {dark: 'var(--black-03)', light: 'var(--white-04)'},
        '--container-border-color-200': {dark: 'var(--black-13)', light: 'var(--slate-02)'},

        '--container-background-color-disabled-100': {dark: 'var(--gray-09)', light: 'var(--slate-04)'},
        '--container-background-color-disabled-200': {dark: '#4f525b', light: 'var(--slate-09)'},
        '--container-background-mask-color-disabled-100': {dark: '#ebf0f800', light: '#ebf0f800'},
        '--container-border-color-disabled-100': {dark: 'var(--gray-08)', light: 'var(--slate-04)'},
        '--container-text-color-disabled-100 ': {dark: 'var(--gray-06)', light: 'var(--label-text-color-200)'},
        '--default-tooltip-background-color': {dark: 'var(--container-background-color-100)', light: 'var(--default)'},
        '--container-background-trans       ': {dark: 'var(--trans-gray-000)    ', light: 'var(--trans-gray-000)'},
        '--container-mask-color-100         ': {
            dark: 'var(--app-background), var(--trans-gray-000)',
            light: 'var(--app-background), var(--trans-gray-000)',
        },
        '--container-mask-color-200         ': {
            dark: 'var(--container-background-color-100), var(--trans-gray-000)  ',
            light: 'var(--container-background-color-100), var(--trans-gray-000)',
        },
        '--container-mask-color-300         ': {
            dark: 'var(--container-background-color-600), var(--trans-gray-000)  ',
            light: 'var(--container-background-color-100), var(--trans-gray-000)',
        },
    })};

    ${formControlColors}
    ${CardColors}
`;
